// src/hooks/usePageTracking.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag || !window.GA_MEASUREMENT_ID) return;

    window.gtag('event', 'page_view', {
      page_location: window.location.href,
      page_path: location.pathname + location.search,
      page_title: document.title,
      send_to: window.GA_MEASUREMENT_ID,
    });
  }, [location]);
}
